/** `value` with every regex metacharacter escaped, so it matches itself literally in a RegExp. */
export const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
